import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class EmailService {
    private composeEmailSubject = new BehaviorSubject<boolean>(false);
    composeEmailChanged = this.composeEmailSubject.asObservable();

    composeEmail(state: boolean): void {
        this.composeEmailSubject.next(state);
    }

    sendEmail(emailData: { to: string[]; cc: string[]; bcc: string[]; subject: string; body: string; attachments: File[] }): Observable<any> {
        console.log('Sending email:', emailData);
        // Replace with actual HTTP call to your email backend service
        // Example: return this.http.post('/api/send-email', emailData);
        return of({ success: true });
    }
}
